// see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort
const abortExceptionName = 'AbortError';

export const isAbortException = (e) => e instanceof DOMException && e.name === abortExceptionName;
